import React from 'react';
import { useTheme } from '@mui/material/styles';
import { alpha } from '@mui/system/colorManipulator';
import { oneOfType, bool, string, number, objectOf } from 'prop-types';
import { Root, IconText } from './styles';

/**
 * Renders circle icon with text inside.
 * @returns {React.FC}
 */

const StepIcon = props => {
  const theme = useTheme();
  const {
    active = false,
    icon,
    style = {},
    showInTooltip = false
  } = props;

  const iconBackground = (active && showInTooltip) ?
    alpha(theme.palette.secondary.main, 0.9) :
    active ? alpha(theme.palette.secondary.main, 0.5) : theme.palette.grey[300];

  return (
    <Root style={style} htmlColor={iconBackground}>
      <circle cx="12" cy="12" r="11" />
      <IconText active={active} showInTooltip={showInTooltip} x="12" y="16" textAnchor="middle">{icon}</IconText>
    </Root>
  );
};

StepIcon.propTypes = {
  active: bool,
  icon: oneOfType([string, number]),
  style: objectOf(oneOfType([string, number]))
};

export default StepIcon;
